let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jDnjw")).then(() => parcelRequire('lxnHp'));